import moment from 'moment'
import APIService from '@/api'

export default class APIReport extends APIService{

    constructor(){
        super('invoices')
    }

    async generateInvoiceHtml(contractId) {
        var response = this.AxiosInstance
            .get(this.ApiUrl + "/invoicehtmldoc", { params: { contractId: contractId } })
            .catch(error => {
                console.log(error.response)
            })

        return response
    }

    sendInvoiceByEmail(contractId) {
      return this.AxiosInstance.post(this.ApiUrl + "/sendinvoicebyemail/" + contractId, {});
    }

}



// WEBPACK FOOTER //
// ./src/api/invoice.js